import React, { useState, useContext } from "react";
import { PatientContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Link } from "react-router-dom";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ComponentWrapper from "./ComponentWrapper";
import FeelingGood from "../../images/feeling-good.svg";
import FeelingNeutral from "../../images/feeling-neutral.svg";
import FeelingBad from "../../images/feeling-bad.svg";
import SubmitButton from "../StyledComponents/SubmitButton";

import { postFeelingToday } from "../../api/TBIRequests";
import { Button } from "react-bootstrap";

const FeelingToday = ({ setDoneSimpleTracking }) => {
  const { t } = useTranslation();
  const { patient } = useContext(PatientContext);

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const [mood, setMood] = useState(0);

  const date = new Date();

  const submitFeeling = (num) => {
    setSubmitting(true);
    const feelingData = {
      severity: num,
      date: date,
    };
    postFeelingToday({
      patientId: patient.patientId,
      data: feelingData,
    })
      .then(() => {
        setDoneSimpleTracking(true);
        setError(false);
        setSubmitting(false);
      })
      .catch(() => {
        setError(true);
        setSubmitting(false);
      });
  };

  const renderLabels = () => {
    const labels = [];
    for (let i = 0; i <= 10; i += 1) {
      labels.push(
        <span key={i} style={{ position: 'absolute', left: `${0.5 + i * 9.7}%` }}>
          {i}
        </span>
      );
    }
    return labels;
  };

  const handleKeyPress = (e, num) => {
    if (e.key === "Enter" || e.key === " ") {
      submitFeeling(num);
    }
  };

  const imgStyle = { cursor: "pointer" };

  return submitting ? (
    <ComponentWrapper>{t("dashboard.feelingToday.submit")}</ComponentWrapper>
  ) : (
    <ComponentWrapper>
      <Col md={12} className="text-center align-items-lg-center">
        {error && (
          <>
            <div>
              {t("dashboard.feelingToday.error.0")}{" "}
              <Link to="/help">{t("dashboard.feelingToday.error.1")}</Link>
              {t("dashboard.feelingToday.error.2")}
            </div>
          </>
        )}
        <div className="ml-2">
          {t("dashboard.feelingToday.label")}
        </div>
        <div style={{ width: '100%' }}>
          <input
            type="range"
            min={0}
            max={10}
            step={1}
            value={mood}
            onChange={event => setMood(event.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ position: 'relative', paddingBottom: "30px", width: '100%' }}>
          {renderLabels()}
        </div>
        <div style={{ position: 'relative', paddingBottom: "30px", width: '100%' }}>
          <span key={"no-problems"} style={{ position: 'absolute', left: `0%` }}>
            {t("dashboard.feelingToday.mood.good")}
          </span>
          <span key={"very-bad"} style={{ position: 'absolute', right: `0%` }}>
            {t("dashboard.feelingToday.mood.bad")}
          </span>
        </div>
        <SubmitButton
          style={{ height: "max-content" }}
          onClick={() => {
            submitFeeling((10 - mood) * 10)
          }}
          type="button"
          centered={true}
          disabled={submitting}
        >
          {t("dashboard.feelingToday.save")}
        </SubmitButton>
      </Col>
    </ComponentWrapper>
  );
};

export default FeelingToday;